import { PermissionNameUnionType } from '@api';
import { PermittedItemType } from '@common';

import { GeneralInformationTableRowType } from '../types';

export const generalInformationRows: (PermittedItemType<PermissionNameUnionType> &
  GeneralInformationTableRowType)[] = [
  { label: 'COMPANY_NAME', accessor: 'name', requiredPermissions: [] },
  { label: 'SHORTNAME', accessor: 'shortName', requiredPermissions: [] },
  { label: 'WEBSITE', accessor: 'website', requiredPermissions: [] },
  { label: 'VAT_ID', accessor: 'vatId', requiredPermissions: [] },
  { label: 'TAGS', accessor: 'tags', requiredPermissions: [] },
  { label: 'NOTES', accessor: 'notes', requiredPermissions: [] },
];
